<template>
    <div>
        {{ $t('notification.driveFileDeleted', { 
            actor: $_.get(activity, 'actorUser.name'), 
            fileName: $_.get(activity, 'payload.fileName')
        }) }}
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "DriveFileDeleted",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

